<!--
 * @Date: 2021-07-14 22:42:26
 * @LastEditors: 于鸿儒
 * @LastEditTime: 2021-07-17 22:17:28
 * @FilePath: /fdmba2021/src/App.vue
-->
<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: 'App',
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  
}
* {
    box-sizing: border-box;
}
body,
div,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
p,
blockquote,
dl,
dt,
dd,
ol,
li,
ul,
pre,
fieldset,
legend,
button,
input,
textarea,
th,
td {
    margin: 0;
    padding: 0;
}
ul,
ol,
li {
    list-style: none;
}
.flex {
  display: flex;
}
body{
  height: 100vh;
  width: 100vw;
  overflow-x: hidden;
  overflow-y: scroll;
  background-image: url('../public/images/bigImg.png');
  background-position: center;
}
</style>
